/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstatusdraft2Inputs */

const en_dropstatusdraft2 = /** @type {(inputs: Dropstatusdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const de_dropstatusdraft2 = /** @type {(inputs: Dropstatusdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Dropstatusdraft2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstatusdraft2 = /** @type {((inputs?: Dropstatusdraft2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstatusdraft2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstatusdraft2(inputs)
	return de_dropstatusdraft2(inputs)
});
export { dropstatusdraft2 as "dropStatusDraft" }